import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { media, mediaQueries } from '../../../style/global-style';

export const StyledSection = styled.section`
    max-width: 100%;
`;

export const StyledOverlay = styled.div`
    position: absolute;
    width: 100%;
    height: 60%;
    bottom: 0;
    z-index: 0;
    left: 0;
    background-image: linear-gradient(
        to top,
        ${(props) => props.theme.colors['main1-50']},
        rgba(0, 35, 59, 0)
    );
    ${media.tablet`display: none;`};
`;
export const StyledBgWrapper = styled.div`
    height: 200px;
    position: relative;
    ${media.tablet`height: 360px;`}
    ${media.smallDesktop`height: 415px;`}
    ${media.desktop`height: 440px;`}
`;

export const StyledStageWrapper = styled.div<{ removePadding?: boolean }>`
    padding-left: ${(props) => props.theme.spacing.large};
    padding-right: ${(props) => props.theme.spacing.large};
    height: 100%;
    @media ${mediaQueries.allTablet} {
        max-width: 970px;
        padding-left: 0;
    }
    @media ${mediaQueries.allDesktop} {
        max-width: 1170px;
    }
    margin: 0 auto;
    ${(props) =>
        props.removePadding &&
        css`
            && {
                padding-left: 0;
                padding-right: 0;
                max-width: 100%;
            }
        `}
`;

export const StyledCompanyHeading = styled.h1`
    font-weight: 600;
    font-size: ${(props) => props.theme.fontSize.headlineM};
    text-align: center;
    text-shadow: 0 0 4px ${(props) => props.theme.dropShadows['black-50']};
    color: ${(props) => props.theme.shades.white};
    display: inline-block;
    margin: 10px 0;
    @media ${mediaQueries.tabletAndUp} {
        text-align: left;
        margin-bottom: 8px;
        font-size: ${(props) => props.theme.fontSize.headlineXL};
    }
    @media ${mediaQueries.desktopAndUp} {
        font-size: ${(props) => props.theme.fontSize.headlineXXL};
        line-height: 1;
    }
`;

export const StyledCompanyLogoWrapper = styled.div`
    float: right;
    width: 95px;
    height: 41px;
    background-color: white;
    overflow: hidden;
    top: 7px;
    position: relative;
    border-radius: 6px;
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.02);

    ${media.tablet`
        width: 120px;
        height: 60px;
        top: 24px;
        right: 24px;
    `};
`;

export const StyledCompanyLogo = styled.div<{ src: string }>`
    padding: 1px;
    width: 100%;
    height: 100%;
    background: url('${(props) => props.src}') no-repeat center center;
    background-size: contain;
`;

export const StyledContentWrapper = styled.span`
    display: inline-flex;
    flex-direction: column;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    ${media.tablet`
        position: static;
        transform: none;
        display: flex;
        flex-direction: row;
        height: 100%;
    `};
`;

export const StyledCustomButtonWrapper = styled.div`
    /* This is a adhoc thing right now. In the future, this will
        be in its own component and we will be able to show that
        variant for tabletAndUp
    */
    @media ${mediaQueries.tabletAndUp} {
        display: none;
    }
`;
